"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const pubsub_1 = __importDefault(require("../utils/pubsub"));
const { getCurrent, subscribe, unsubscribe, publish, reset } = pubsub_1.default();
/**
 * Store and retrieve values from shared state. The same key may be used across
 * components; subscriptions will keep data in sync.
 *
 * @param {string} key the key for dereferencing the shared state; may
 *                     not change across renders
 * @param {*} initialValue the initial value if the item doesn't yet exist
 *                         in local or shared state
 * @returns {[*, Function]} the current value and a function for updating it
 *
 */
const useSharedState = (key, initialValue) => {
    const [value, setValue] = react_1.useState(getCurrent(key, initialValue));
    react_1.useEffect(() => {
        subscribe(key, setValue);
        return () => unsubscribe(key, setValue);
    }, [key]);
    return [value, react_1.useCallback(v => publish(key, v), [key])];
};
// easy way to drop all subscribers and clear lastValues so we don't have
// to explicitly unmount everything in tests
useSharedState.reset = reset;
exports.default = useSharedState;
//# sourceMappingURL=useSharedState.js.map